/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pay_from_medium'
export default icon
